import { COUNTRY } from '@/global'
import { t } from '@/plugins/i18n'
import flag_zh from '@/assets/image/logos/flag-icon-zh.svg'
import flag_ko from '@/assets/image/logos/flag-icon-ko.svg'
import { useRoute, useRouter } from 'vue-router'
import { computed, reactive, ref, watch } from 'vue'
import { isMultiStore } from '@/store'
import { useStore } from 'vuex'
import { ShopType } from '@/common/const'
import { get, set } from 'lodash'

enum Currency {
  CNY = 'CNY',
  KRW = 'KRW',
}

export const countrys = reactive([
  { name: COUNTRY.CN, label: t('china'), currency: Currency.CNY, flagIcon: flag_zh, cart: (count: number) => t('中国商品购物车') + `(${count})` },
  { name: COUNTRY.KR, label: t('korea'), currency: Currency.KRW, flagIcon: flag_ko, cart: (count: number) => t('韩国商品购物车') + `(${count})` }
])

export const useNav = (options?: any) => {
  const router = useRouter()
  const route = useRoute()
  const setQuery = (query: any, replace?: boolean) => {
    router.push({
      name: route.name as string,
      query: {
        ...route.query,
        ...query
      }
    })
  }
  return { router, route, setQuery }
}

const params = new URLSearchParams(location.search)

export const sourceCountryRef = ref<COUNTRY>(params.get('sc') as COUNTRY ?? COUNTRY.CN)

export const setLastTiktokWare = (ware: COUNTRY = COUNTRY.CN) => {
  localStorage.setItem('lastTiktokWare', ware)
  sourceCountryRef.value = ware
}
export const getLastTiktokWare = () => {
  const ware = localStorage.getItem('lastTiktokWare') as COUNTRY
  return ware ? (ware as COUNTRY) : COUNTRY.CN
}

export const useSourceCountry = () => {
  const { route, setQuery } = useNav()
  const store = useStore()
  // const isTikTokShop = computed(() => Number(store.getters.shopInfo?.customerShopPlatform) === ShopType.TIKTOK)
  const country = computed<COUNTRY>(() => {
    const val = route.query.sc as COUNTRY || COUNTRY.CN
    if (val === COUNTRY.CN) {
      sourceCountryRef.value = getLastTiktokWare()
    } else {
      sourceCountryRef.value = val
    }
    return val
  })

  const changeCountry = (c: COUNTRY) => setQuery({ sc: c })
  return [country, changeCountry] as const
}

export const concatProducts = () => {

}

export const sourceCountryInfo = computed(() => countrys.find((v) => v.name === (sourceCountryRef.value === COUNTRY.KR ? COUNTRY.KR : COUNTRY.CN)))

const currency = {
  [COUNTRY.CN]: {
    symbol: '￥',
    code: 'CNY',
    local: 'zh-CN',
    name: t('元')
  },
  CNY: {
    symbol: '￥',
    code: 'CNY',
    local: 'zh-CN',
    name: t('元')
  },
  [COUNTRY.KR]: {
    symbol: '₩',
    code: 'KRW',
    local: 'ko-KR',
    name: t('韩元')
  },
  KRW: {
    symbol: '₩',
    code: 'KRW',
    local: 'ko-KR',
    name: t('韩元')
  },
  [COUNTRY.JP]: {
    symbol: '￥',
    code: 'JPY',
    local: 'ja-JP',
    name: '円'
  },
  JPY: {
    symbol: '￥',
    code: 'JPY',
    local: 'ja-JP',
    name: '円'
  }
}

export const tCurrency = (str: string, sc?: COUNTRY) => {
  const local = currency[sc ?? (sourceCountryRef.value === COUNTRY.KR ? COUNTRY.KR : COUNTRY.CN)]
  // 临时先这样吧，不用改老代码^_^
  if (str === '元') {
    return ' ' + local.name
  }
  if (str === 'CNY') {
    return ' ' + local.code
  }
  if (str === '￥') {
    return ' ' + local.symbol
  }
}

// 囤货选择的仓库信息
export const stockWarehouse = ref('CN')
